import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, Fragment as _Fragment, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "fas fa-caret-square-up"
}
const _hoisted_2 = {
  key: 1,
  class: "fas fa-caret-square-down"
}
const _hoisted_3 = { class: "p-grid" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("span", { class: "p-col-3 p-sm-4 p-md-3" }, [
  /*#__PURE__*/_createElementVNode("strong", null, "Nome:")
], -1)
const _hoisted_5 = { class: "p-col-9 p-sm-8 p-md-6" }
const _hoisted_6 = { class: "p-grid" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("span", { class: "p-col-3 p-sm-4 p-md-3" }, [
  /*#__PURE__*/_createElementVNode("strong", null, "Telefono:")
], -1)
const _hoisted_8 = { class: "p-col-9 p-sm-8 p-md-6" }
const _hoisted_9 = ["href"]
const _hoisted_10 = /*#__PURE__*/_createTextVNode("--")
const _hoisted_11 = { class: "p-grid" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("span", { class: "p-col-3 p-sm-4 p-md-3" }, [
  /*#__PURE__*/_createElementVNode("strong", null, "Indirizzo:")
], -1)
const _hoisted_13 = { class: "p-col-9 p-sm-8 p-md-6" }
const _hoisted_14 = { class: "p-grid p-mt-3" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("span", { class: "p-col-3 p-sm-4 p-md-3" }, [
  /*#__PURE__*/_createElementVNode("strong", null, "Note:")
], -1)
const _hoisted_16 = { class: "p-col-9 p-sm-8 p-md-6" }
const _hoisted_17 = {
  key: 0,
  class: "p-field-checkbox"
}
const _hoisted_18 = { for: "save_pickup" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Checkbox = _resolveComponent("Checkbox")!
  const _component_Card = _resolveComponent("Card")!

  return (_openBlock(), _createBlock(_component_Card, null, {
    title: _withCtx(() => [
      (_ctx.type === 'ritiro')
        ? (_openBlock(), _createElementBlock("i", _hoisted_1))
        : (_openBlock(), _createElementBlock("i", _hoisted_2)),
      _createTextVNode(" Punto di " + _toDisplayString(_ctx.type), 1)
    ]),
    content: _withCtx(() => [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.picker.picker_name), 1)
      ]),
      _createElementVNode("div", _hoisted_6, [
        _hoisted_7,
        _createElementVNode("span", _hoisted_8, [
          (_ctx.picker.phone)
            ? (_openBlock(), _createElementBlock("a", {
                key: 0,
                href: `tel:${_ctx.picker.phone}`
              }, _toDisplayString(_ctx.picker.phone), 9, _hoisted_9))
            : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                _hoisted_10
              ], 64))
        ])
      ]),
      _createElementVNode("div", _hoisted_11, [
        _hoisted_12,
        _createElementVNode("span", _hoisted_13, _toDisplayString(_ctx.picker.full_address || '--'), 1)
      ]),
      _createElementVNode("div", _hoisted_14, [
        _hoisted_15,
        _createElementVNode("p", _hoisted_16, _toDisplayString(_ctx.picker.note || '--'), 1)
      ]),
      (!_ctx.picker?.picker_id && !_ctx.hideSave)
        ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
            _createVNode(_component_Checkbox, {
              id: "save_pickup",
              binary: true,
              "model-value": _ctx.savePicker,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('update:savePicker', $event)))
            }, null, 8, ["model-value"]),
            _createElementVNode("label", _hoisted_18, "Salva nuovo punto di " + _toDisplayString(_ctx.type), 1)
          ]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}